import React, { useCallback, useState } from 'react'
import {
	Grid,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Typography,
	TextField
} from '@material-ui/core'
import debounce from 'lodash.debounce'
import { useNavigate } from 'react-router-dom'

import useIntl from 'hooks/useIntl'
import { useOnboardingStore } from 'screens/Onboarding/hooks/useOnboardingStore'
import { ContentWrapper } from 'screens/Onboarding/components/ContentWrapper'
import { CreationContent } from 'components/CreationContent'
import WizardFooter from 'components/Wizard/WizardFooter'
import { useEntryFormStore } from '../../hooks/useEntryFormStore'

export const EntryFormChapterSelection = ({ setNumOfQuestions }) => {
	const intl = useIntl()
	const navigate = useNavigate()
	const [questionError, setQuestionError] = useState(false)

	const [debounceSearch, setDebounceSearch] = useState('')
	const debouncedSearch = useCallback(
		debounce(nextValue => setDebounceSearch(nextValue), 300),
		[]
	)

	const { nextStep, currentStep, toggleHelpGuide } = useOnboardingStore()
	const { formData, setFormData } = useEntryFormStore()

	const handleContinue = () => {
		nextStep()
	}

	const convertDurationToMinutes = (time: string): number => {
		if (!time) return 0

		const [hours, minutes] = time.split(':').map(Number)
		return hours * 60 + minutes
	}

	const handleChange = event => {
		const { name, value } = event.target
		setFormData({ ...formData, [name]: value })
	}

	const durationOptions = Array.from({ length: 60 }, (_, i) => {
		const minutes = (i + 1) * 5
		const hours = Math.floor(minutes / 60)
		const remainingMinutes = minutes % 60
		const formattedTime = `${String(hours).padStart(2, '0')}:${String(
			remainingMinutes
		).padStart(2, '0')} ${hours > 0 ? 'hrs' : 'min'}`

		return { value: formattedTime, label: formattedTime }
	})

	const questionPickingOptions = [
		{ value: 'true', label: 'Auto Pick' },
		{ value: 'false', label: 'Manual' }
	]

	const isContinueEnabled =
		formData.questions !== '' && formData.timer !== '' && formData.picking !== ''

	return (
		<>
			<ContentWrapper currentStep={currentStep}>
				{/* <CreationContent
					subHeader
					subTitle={intl.formatMessage({
						id: 'onboarding.select.entry.form.title'
					})}
				> */}
				<CreationContent
					subHeader
					title={intl.formatMessage({
						id: 'onboarding.select.entry.form.subTitle.1'
					})}
					subTitle={intl.formatMessage({
						id: 'onboarding.select.entry.form.title'
					})}
				>
					{/* <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
						Assessment Details
					</Typography> */}
					<Grid container spacing={2} sx={{ mt: 2 }}>
						<Grid item xs={6} sm={2}>
							<FormControl variant="outlined" fullWidth>
								<Typography variant="body2" gutterBottom>
									No. of Questions
								</Typography>
								<TextField
									type="number"
									placeholder="Enter a number"
									size="small"
									sx={{ height: '40px' }}
									value={formData.questions || ''}
									name="questions"
									onChange={e => {
										const value = parseInt(e.target.value, 10) || 0
										setNumOfQuestions(value)
										handleChange(e)
										setQuestionError(value <= 0) // <-- for helper text condition
									}}
									fullWidth
									error={questionError}
									helperText={questionError ? 'Please enter a number greater than 0' : ''}
									inputProps={{ min: 1 }}
								/>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={4}>
							<FormControl fullWidth>
								<InputLabel>
									Duration{' '}
									<span style={{ color: 'gray', fontSize: '12px' }}>(HH : MM)</span>{' '}
								</InputLabel>
								<TextField
									select
									name="timer"
									value={formData.timer}
									onChange={handleChange}
									SelectProps={{
										MenuProps: {
											getContentAnchorEl: null,
											anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
											transformOrigin: { vertical: 'top', horizontal: 'left' },
											PaperProps: { style: { maxHeight: 200, overflowY: 'auto' } }
										},
										displayEmpty: true
									}}
								>
									<MenuItem value="" disabled>
										Select a Duration
									</MenuItem>
									{durationOptions.map(option => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</TextField>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={4}>
							<FormControl fullWidth>
								<InputLabel>Question Picking</InputLabel>
								<Select
									name="picking"
									value={formData.picking}
									onChange={handleChange}
									MenuProps={{
										getContentAnchorEl: null,
										anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
										transformOrigin: { vertical: 'top', horizontal: 'left' },
										PaperProps: { style: { maxHeight: 200, overflowY: 'auto' } }
									}}
								>
									{questionPickingOptions.map(option => (
										<MenuItem
											key={option.value}
											value={option.value}
											disabled={option.value === 'false'}
										>
											{option.label}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
					</Grid>
				</CreationContent>
			</ContentWrapper>

			{/* Footer */}
			<WizardFooter
				onOpenHelpGuide={toggleHelpGuide}
				continueDisabled={!isContinueEnabled}
				onContinue={handleContinue}
				onBack={() => navigate('/onboarding/challenges-selection')}
			/>
		</>
	)
}

export default EntryFormChapterSelection
